export default "https://msvcweuwebsiteprod.blob.core.windows.net/bundles/frontend/dist/wolf/images/marker.7b5d6370.svg";